import { render, staticRenderFns } from "./product-details-modal.vue?vue&type=template&id=96b07194&scoped=true&"
import script from "./product-details-modal.vue?vue&type=script&lang=js&"
export * from "./product-details-modal.vue?vue&type=script&lang=js&"
import style0 from "./product-details-modal.vue?vue&type=style&index=0&id=96b07194&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b07194",
  null
  
)

export default component.exports